import React from 'react';
import { Image } from 'lucide-react';
import SocialIcon from 'components/SocialIcon';
import {
  CLIENT_FOCUS, COUNTRIES, GROWTH_STAGE, INCOME_STREAMS, INDUSTRIES, REVENUES, SUB_INDUSTRIES,
} from '.';

export const defaultCompanyFounderQuestions = [
  {
    id: 'externalId',
    type: 'text',
    title: 'externalId',
    placeholder: 'XXXXXX-XX-XXXXXXXX-XXXX-XXXXXXX',
    mandatory: false,
    admin: true,
  },
  {
    id: 'logo',
    title: 'uploadLogo',
    placeholder: 'logo',
    type: 'avatar',
    image: <Image size={60} className='file-icon' />,
    mandatory: false,
  },
  {
    id: 'name',
    type: 'text',
    title: 'startupName',
    placeholder: 'startupName',
    mandatory: true,
  },
  {
    id: 'description',
    type: 'textarea',
    title: 'description',
    placeholder: 'description',
    mandatory: true,
  },
  {
    id: 'country',
    title: 'country',
    placeholder: 'country',
    type: 'select',
    answers: COUNTRIES,
    mandatory: false,
    literals: 'countries',
  },
  // {
  // id: 'legalForm',
  // mandatory: false,
  // placeholder: 'legalForm',
  // title: 'legalForm',
  // type: 'select',
  // answers: [
  //   { order: 0, text: { es: 'SE', en: 'SE' }, id: 'EU100' },
  //   { order: 1, text: { es: 'SCE', en: 'SCE' }, id: 'EU200' },
  //   { order: 2, text: { es: 'EEIG', en: 'EEIG' }, id: 'EU300' },
  //   { order: 3, text: { es: 'EGTC', en: 'EGTC' }, id: 'EU400' },
  //   { order: 4, text: { es: 'OG', en: 'OG' }, id: 'AT102' },
  //   { order: 5, text: { es: 'KG', en: 'KG' }, id: 'AT103' },
  //   { order: 6, text: { es: 'AG', en: 'AG' }, id: 'AT201' },
  //   { order: 7, text: { es: 'GmbH', en: 'GmbH' }, id: 'AT202' },
  //   { order: 8, text: { es: 'GEN', en: 'GEN' }, id: 'AT401' },
  //   { order: 9, text: { es: 'ASBL/VZW/VoG', en: 'ASBL/VZW/VoG' }, id: 'BE017' },
  //   { order: 10, text: { es: 'SA/NV/AG', en: 'SA/NV/AG' }, id: 'BE014' },
  //   { order: 11, text: { es: 'SC/CV/Gen', en: 'SC/CV/Gen' }, id: 'BE706' },
  //   { order: 12, text: { es: 'SComm/CommV/KommG', en: 'SComm/CommV/KommG' }, id: 'BE612' },
  //   { order: 13, text: { es: 'SDC/MS/GaR', en: 'SDC/MS/GaR' }, id: 'BE702' },
  //   { order: 14, text: { es: 'SNC/V.O.F./OHG', en: 'SNC/V.O.F./OHG' }, id: 'BE011' },
  //   { order: 15, text: { es: 'SPRL/BVBA/PGmbH', en: 'SPRL/BVBA/PGmbH' }, id: 'BE015' },
  //   { order: 16, text: { es: 'SRL/BV/GmbH', en: 'SRL/BV/GmbH' }, id: 'BE610' },
  //   { order: 17, text: { es: 'OOD', en: 'OOD' }, id: 'BG102' },
  //   { order: 18, text: { es: 'EOOD', en: 'EOOD' }, id: 'BG105' },
  //   { order: 19, text: { es: 'KD', en: 'KD' }, id: 'BG106' },
  //   { order: 20, text: { es: 'SD/S-ie', en: 'SD/S-ie' }, id: 'BG107' },
  //   { order: 21, text: { es: 'ET', en: 'ET' }, id: 'BG462' },
  //   { order: 22, text: { es: 'Coop', en: 'Coop' }, id: 'BG466' },
  //   { order: 23, text: { es: 'd.o.o.', en: 'd.o.o.' }, id: 'HR02' },
  //   { order: 24, text: { es: 'k.d.', en: 'k.d.' }, id: 'HR04' },
  //   { order: 25, text: { es: 'Udruga', en: 'Udruga' }, id: 'HR47' },
  //   { order: 26, text: { es: 'Zadruga', en: 'Zadruga' }, id: 'HR53' },
  //   { order: 27, text: { es: 'LTD', en: 'LTD' }, id: 'CY102' },
  //   { order: 28, text: { es: 'PLC', en: 'PLC' }, id: 'CY103' },
  //   { order: 29, text: { es: 'P', en: 'P' }, id: 'CY109' },
  //   { order: 30, text: { es: 'SP', en: 'SP' }, id: 'CY112' },
  //   { order: 31, text: { es: 'v.o.s.', en: 'v.o.s.' }, id: 'CZ111' },
  //   { order: 32, text: { es: 's.r.o.', en: 's.r.o.' }, id: 'CZ112' },
  //   { order: 33, text: { es: 'k.s.', en: 'k.s.' }, id: 'CZ113' },
  //   { order: 34, text: { es: 'a.s.', en: 'a.s.' }, id: 'CZ121' },
  //   { order: 35, text: { es: 's.m.b.a.', en: 's.m.b.a.' }, id: 'DK151' },
  //   { order: 36, text: { es: 'I/S', en: 'I/S' }, id: 'DK30' },
  //   { order: 37, text: { es: 'K/S', en: 'K/S' }, id: 'DK40' },
  //   { order: 38, text: { es: 'A/S', en: 'A/S' }, id: 'DK60' },
  //   { order: 39, text: { es: 'ApS', en: 'ApS' }, id: 'DK80' },
  //   { order: 40, text: { es: 'AS', en: 'AS' }, id: 'EE101' },
  //   { order: 41, text: { es: 'OÜ', en: 'OÜ' }, id: 'EE102' },
  //   { order: 42, text: { es: 'TÜ', en: 'TÜ' }, id: 'EE201' },
  //   { order: 43, text: { es: 'UÜ', en: 'UÜ' }, id: 'EE202' },
  //   { order: 44, text: { es: 'MTÜ', en: 'MTÜ' }, id: 'EE203' },
  //   { order: 45, text: { es: 'ay', en: 'ay' }, id: 'FI10' },
  //   { order: 46, text: { es: 'ky/kb', en: 'ky/kb' }, id: 'FI11' },
  //   { order: 47, text: { es: 'oy/oyj/ab/abp', en: 'oy/oyj/ab/abp' }, id: 'FI12' },
  //   { order: 48, text: { es: 'osk', en: 'osk' }, id: 'FI25' },
  //   { order: 49, text: { es: 'SLP', en: 'SLP' }, id: 'FR5130' },
  //   { order: 50, text: { es: 'SARL', en: 'SARL' }, id: 'FR5410' },
  //   { order: 51, text: { es: 'SA', en: 'SA' }, id: 'FR5660' },
  //   { order: 52, text: { es: 'OHG', en: 'OHG' }, id: 'DE102' },
  //   { order: 53, text: { es: 'KG', en: 'KG' }, id: 'DE103' },
  //   { order: 54, text: { es: 'AG', en: 'AG' }, id: 'DE201' },
  //   { order: 55, text: { es: 'GmbH', en: 'GmbH' }, id: 'DE206' },
  //   { order: 56, text: { es: 'eG', en: 'eG' }, id: 'DE301' },
  //   { order: 57, text: { es: 'OE', en: 'OE' }, id: 'GR902' },
  //   { order: 58, text: { es: 'EE', en: 'EE' }, id: 'GR903' },
  //   { order: 59, text: { es: 'SA', en: 'SA' }, id: 'GR905' },
  //   { order: 60, text: { es: 'EPE', en: 'EPE' }, id: 'GR906' },
  //   { order: 61, text: { es: 'IKE', en: 'IKE' }, id: 'GR907' },
  //   { order: 62, text: { es: 'COOP', en: 'COOP' }, id: 'GR910' },
  //   { order: 63, text: { es: 'Kft.', en: 'Kft.' }, id: 'HU113' },
  //   { order: 64, text: { es: 'Rt.', en: 'Rt.' }, id: 'HU114' },
  //   { order: 65, text: { es: 'Kkt.', en: 'Kkt.' }, id: 'HU116' },
  //   { order: 66, text: { es: 'Bt.', en: 'Bt.' }, id: 'HU117' },
  //   { order: 67, text: { es: 'Kht.', en: 'Kht.' }, id: 'HU736' },
  //   { order: 68, text: { es: 'LTD', en: 'LTD' }, id: 'IE01' },
  //   { order: 69, text: { es: 'PLC', en: 'PLC' }, id: 'IE05' },
  //   { order: 70, text: { es: 'SMC', en: 'SMC' }, id: 'IE06' },
  //   { order: 71, text: { es: 'SNC', en: 'SNC' }, id: 'IT201' },
  //   { order: 72, text: { es: 'SAS', en: 'SAS' }, id: 'IT301' },
  //   { order: 73, text: { es: 'COOP', en: 'COOP' }, id: 'IT601' },
  //   { order: 74, text: { es: 'SPA', en: 'SPA' }, id: 'IT701' },
  //   { order: 75, text: { es: 'SAA', en: 'SAA' }, id: 'IT702' },
  //   { order: 76, text: { es: 'SRL', en: 'SRL' }, id: 'IT703' },
  //   { order: 77, text: { es: 'BDR', en: 'BDR' }, id: 'LV807' },
  //   { order: 78, text: { es: 'GIM', en: 'GIM' }, id: 'LV301' },
  //   { order: 79, text: { es: 'KB', en: 'KB' }, id: 'LV401' },
  //   { order: 80, text: { es: 'KS', en: 'KS' }, id: 'LV108' },
  //   { order: 81, text: { es: 'PS', en: 'PS' }, id: 'LV107' },
  //   { order: 82, text: { es: 'SIA', en: 'SIA' }, id: 'LV103' },
  //   { order: 83, text: { es: 'AB', en: 'AB' }, id: 'LT101' },
  //   { order: 84, text: { es: 'UAB', en: 'UAB' }, id: 'LT102' },
  //   { order: 85, text: { es: 'KO', en: 'KO' }, id: 'LT103' },
  //   { order: 86, text: { es: 'TUB', en: 'TUB' }, id: 'LT104' },
  //   { order: 87, text: { es: 'KUB', en: 'KUB' }, id: 'LT105' },
  //   { order: 88, text: { es: 'A', en: 'A' }, id: 'LT106' },
  //   { order: 89, text: { es: 'II', en: 'II' }, id: 'LT109' },
  //   { order: 90, text: { es: 'EI', en: 'EI' }, id: 'LU01' },
  //   { order: 91, text: { es: 'SARL', en: 'SARL' }, id: 'LU03' },
  //   { order: 92, text: { es: 'SECS', en: 'SECS' }, id: 'LU05' },
  //   { order: 93, text: { es: 'SA', en: 'SA' }, id: 'LU07' },
  //   { order: 94, text: { es: 'SCOP', en: 'SCOP' }, id: 'LU12' },
  //   { order: 95, text: { es: 'PCOMM', en: 'PCOMM' }, id: 'MT020' },
  //   { order: 96, text: { es: 'P', en: 'P' }, id: 'MT021' },
  //   { order: 97, text: { es: 'LTD', en: 'LTD' }, id: 'MT030' },
  //   { order: 98, text: { es: 'VO', en: 'VO' }, id: 'MT040' },
  //   { order: 99, text: { es: 'PLC', en: 'PLC' }, id: 'MT060' },
  //   { order: 100, text: { es: 'COOP', en: 'COOP' }, id: 'MT080' },
  //   { order: 101, text: { es: 'BV', en: 'BV' }, id: 'NL101' },
  //   { order: 102, text: { es: 'NV', en: 'NV' }, id: 'NL102' },
  //   { order: 103, text: { es: 'Coöperatie', en: 'Coöperatie' }, id: 'NL201' },
  //   { order: 104, text: { es: 'sp. z o.o.', en: 'sp. z o.o.' }, id: 'PLA117' },
  //   { order: 105, text: { es: 'sp.k.', en: 'sp.k.' }, id: 'PLA120' },
  //   { order: 106, text: { es: 'spółdzielnie', en: 'spółdzielnie' }, id: 'PLA140' },
  //   { order: 107, text: { es: 'Assoc', en: 'Assoc' }, id: 'PT221' },
  //   { order: 108, text: { es: 'Coman', en: 'Coman' }, id: 'PT141' },
  //   { order: 109, text: { es: 'Coop', en: 'Coop' }, id: 'PT211' },
  //   { order: 110, text: { es: 'Lda', en: 'Lda' }, id: 'PT121' },
  //   { order: 111, text: { es: 'SA', en: 'SA' }, id: 'PT131' },
  //   { order: 112, text: { es: 'SNC', en: 'SNC' }, id: 'PT151' },
  //   { order: 113, text: { es: 'SUni', en: 'SUni' }, id: 'PT122' },
  //   { order: 114, text: { es: 'SRL', en: 'SRL' }, id: 'RO102' },
  //   { order: 115, text: { es: 'SCS', en: 'SCS' }, id: 'RO103' },
  //   { order: 116, text: { es: 'ONG', en: 'ONG' }, id: 'RO107' },
  //   { order: 117, text: { es: 'SNC', en: 'SNC' }, id: 'RO108' },
  //   { order: 118, text: { es: 'v.o.s', en: 'v.o.s' }, id: 'SK111' },
  //   { order: 119, text: { es: 'k. s.', en: 'k. s.' }, id: 'SK113' },
  //   { order: 120, text: { es: 'N.O.', en: 'N.O.' }, id: 'SK119' },
  //   { order: 121, text: { es: 's.r.o.', en: 's.r.o.' }, id: 'SK112' },
  //   { order: 122, text: { es: 'Družstvo', en: 'Družstvo' }, id: 'SK205' },
  //   { order: 123, text: { es: 'd.d.', en: 'd.d.' }, id: 'SI104' },
  //   { order: 124, text: { es: 'd.o.o.', en: 'd.o.o.' }, id: 'SI103' },
  //   { order: 125, text: { es: 'k.d.', en: 'k.d.' }, id: 'SI102' },
  //   { order: 126, text: { es: 'z.o.o.', en: 'z.o.o.' }, id: 'SI112' },
  //   { order: 127, text: { es: 'zadruga', en: 'zadruga' }, id: 'SI719' },
  //   { order: 128, text: { es: 'S COOP', en: 'S COOP' }, id: 'ESC14' },
  //   { order: 129, text: { es: 'S. COM. P.A.', en: 'S. COM. P.A.' }, id: 'ESC13' },
  //   { order: 130, text: { es: 'SA', en: 'SA' }, id: 'ESC04' },
  //   { order: 131, text: { es: 'SAU', en: 'SAU' }, id: 'ESC05' },
  //   { order: 132, text: { es: 'SC/SRC', en: 'SC/SRC' }, id: 'ESC11' },
  //   { order: 133, text: { es: 'SL/SRL', en: 'SL/SRL' }, id: 'ESC07' },
  //   { order: 134, text: { es: 'HB, KB', en: 'HB, KB' }, id: 'SE31' },
  //   { order: 135, text: { es: 'corp', en: 'corp' }, id: 'GB100' },
  //   { order: 136, text: { es: 'coop', en: 'coop' }, id: 'GB200' },
  //   { order: 137, text: { es: 'GP', en: 'GP' }, id: 'GB300' },
  //   { order: 138, text: { es: 'LLP', en: 'LLP' }, id: 'GB400' },
  //   { order: 139, text: { es: 'LP', en: 'LP' }, id: 'GB500' },
  //   { order: 140, text: { es: 'LLC', en: 'LLC' }, id: 'GB600' },
  // ],
  // filterAnswers: (answers, formAnswers) => {
  //   const filteredIds = {
  //     AUT: ['AT102', 'AT103', 'AT201, AT202', 'AT401'],
  //     BEL: ['BE017', 'BE014', 'BE706', 'BE612', 'BE702', 'BE011', 'BE015', 'BE610'],
  //     BGR: ['BG102', 'BG105', 'BG106', 'BG107', 'BG462', 'BG466'],
  //     HRV: ['HR02', 'HR04', 'HR47', 'HR53'],
  //     CYP: ['CY102', 'CY103', 'CY109', 'CY112'],
  //     CZE: ['CZ111', 'CZ112', 'CZ113', 'CZ121'],
  //     DNK: ['DK30', 'DK40', 'DK60', 'DK80', 'DK151'],
  //     EST: ['EE101', 'EE102', 'EE201', 'EE202', 'EE203'],
  //     FIN: ['FI10', 'FI11', 'FI12', 'FI25'],
  //     FRA: ['FR5130', 'FR5410', 'FR5660'],
  //     DEU: ['DE102', 'DE103', 'DE201', 'DE206', 'DE301'],
  //     GRC: ['GR902', 'GR903', 'GR905', 'GR906', 'GR907', 'GR910'],
  //     HUN: ['HU113', 'HU114', 'HU116', 'HU117', 'HU736'],
  //     IRL: ['IE01', 'IE05', 'IE06'],
  //     ITA: ['IT201', 'IT301', 'IT601', 'IT701', 'IT702', 'IT703'],
  //     LVA: ['LV807', 'LV301', 'LV401', 'LV108', 'LV107', 'LV103'],
  //     LTU: ['LT101', 'LT102', 'LT103', 'LT104', 'LT105', 'LT106', 'LT109'],
  //     LUX: ['LU01', 'LU03', 'LU05', 'LU07', 'LU12'],
  //     MLT: ['MT020', 'MT021', 'MT030', 'MT040', 'MT060', 'MT080'],
  //     NLD: ['NL101', 'NL102', 'NL201'],
  //     POL: ['PLA117', 'PLA120', 'PLA140'],
  //     PRT: ['PT221', 'PT141', 'PT211', 'PT121', 'PT131', 'PT151', 'PT122'],
  //     ROU: ['RO102', 'RO103', 'RO107', 'RO108'],
  //     SVK: ['SK111', 'SK113', 'SK119', 'SK112', 'SK205'],
  //     SVN: ['SI104', 'SI103', 'SI102', 'SI112', 'SI719'],
  //     ESP: ['ESC14', 'ESC13', 'ESC04', 'ESC05', 'ESC11', 'ESC07'],
  //     SWE: ['SE31'],
  //     GBR: ['GB100', 'GB200', 'GB300', 'GB400', 'GB500', 'GB600'],
  //   };
  //   return filteredIds[formAnswers.country]
  //     ? answers.filter(answer => filteredIds[formAnswers.country].includes(answer.id))
  //     : [];
  // },
  // },
  {
    id: 'city',
    type: 'text',
    title: 'city',
    placeholder: 'city',
    mandatory: false,
  },
  {
    id: 'currency',
    title: 'currency',
    placeholder: 'mainCurrency',
    type: 'select',
    answers: ['EUR', 'USD', 'GBP', 'CHF', 'CNY', 'HKD', 'JPY', 'AUD'],
    literals: 'currencies',
    mandatory: true,
  },
  {
    id: 'taxId',
    type: 'text',
    title: 'taxid',
    placeholder: 'taxid',
    mandatory: false,
  },
  {
    id: 'url',
    type: 'text',
    title: 'URL',
    placeholder: 'url',
    icon: <SocialIcon type='url' />,
    mandatory: false,
  },
  {
    id: 'constitutionDate',
    type: 'date',
    title: 'constitutionDate',
    placeholder: 'constitutionDate',
    mandatory: false,
  },
  {
    id: 'legalName',
    type: 'text',
    title: 'legalName',
    placeholder: 'legalName',
    mandatory: false,
  },
  {
    id: 'social',
    title: 'otherLinks',
    inputs: [
      {
        id: 'social.crunchbase',
        type: 'text',
        placeholder: 'Crunchbase',
        icon: <SocialIcon type='crunchbase' />,
        mandatory: false,
      },
      {
        id: 'social.linkedin',
        type: 'text',
        placeholder: 'Linkedin',
        icon: <SocialIcon type='linkedin' />,
        mandatory: false,
      },
      {
        id: 'social.facebook',
        type: 'text',
        placeholder: 'Facebook',
        icon: <SocialIcon type='facebook' />,
        mandatory: false,
      },
      {
        id: 'social.twitter',
        type: 'text',
        placeholder: 'Twitter',
        icon: <SocialIcon type='twitter' />,
        mandatory: false,
      },
      {
        id: 'social.other',
        type: 'text',
        placeholder: 'other',
        icon: <SocialIcon type='other' />,
        mandatory: false,
      },
    ],
  },
  {
    id: 'growthStage',
    title: 'growthStage',
    placeholder: 'growthStage',
    type: 'select',
    answers: GROWTH_STAGE,
    mandatory: false,
  },
  {
    id: 'industries',
    mandatory: false,
    placeholder: 'industries',
    title: 'industries',
    type: 'list',
    answers: INDUSTRIES,
  },
  {
    id: 'subIndustries',
    mandatory: false,
    placeholder: 'subindustries',
    title: 'subindustries',
    tooltip: '',
    type: 'list',
    answers: SUB_INDUSTRIES,
  },
  {
    id: 'clientFocus',
    mandatory: false,
    placeholder: 'clientFocus',
    title: 'clientFocus',
    type: 'list',
    answers: CLIENT_FOCUS,
  },
  {
    id: 'incomeStreams',
    mandatory: false,
    placeholder: 'incomeStreams',
    title: 'incomeStreams',
    type: 'list',
    answers: INCOME_STREAMS,
  },
  {
    id: 'revenues',
    mandatory: false,
    placeholder: 'revenues',
    title: 'revenues',
    type: 'list',
    answers: REVENUES,
  },
];
